import { FileText } from 'lucide-react';
import type { OriginalPdf } from '../../api/originalPdfs';
import '../ui/Button.css';

export function OriginalPdfLink({
  pdf,
  label = 'Original PDF',
}: {
  pdf: OriginalPdf | null;
  label?: string;
}) {
  if (!pdf) return null;
  return (
    <a
      className="sedlex-btn sedlex-btn--secondary sedlex-btn--sm"
      href={pdf.href}
      target="_blank"
      rel="noopener"
      aria-label={`Open original PDF: ${pdf.title} (new tab)`}
      title={`Original published document: ${pdf.title}`}
    >
      <FileText aria-hidden="true" size={14} /> {label}
    </a>
  );
}
